import { render, staticRenderFns } from "./EmitenteTelefones.vue?vue&type=template&id=a57b9728&scoped=true"
import script from "./EmitenteTelefones.vue?vue&type=script&lang=js"
export * from "./EmitenteTelefones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57b9728",
  null
  
)

export default component.exports